import { Component, OnInit } from '@angular/core'
import { CondOperator } from '@nestjsx/crud-request'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { filter, switchMap, take } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { saleSelectors } from '../sale.selectors'
import { Sale } from '../sale'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import DEBOUNCED_TIME = Constants.DEBOUNCED_TIME
import { Constants } from 'src/app/shared/constants'
import { Actions } from '@ngrx/effects'
import { SearchConfig } from 'src/app/shared/interfaces'

@UntilDestroy()
@Component({
  selector: 'sale-activities-main-tab',
  templateUrl: './sale-activities-tab.component.html',
  styleUrls: ['./sale-activities-tab.component.scss']
})
export class SaleActivitiesMainTabComponent implements OnInit {
  public sale$: Observable<Sale>
  public extraFilters: SearchConfig = {}
  constructor(private store: Store<AppState>, private actions$: Actions) {}

  ngOnInit() {
    this.sale$ = this.store.select(saleSelectors.selectIdRouteParam).pipe(
      filter((saleId) => Boolean(saleId)),
      switchMap((saleId) =>
        this.store.select(saleSelectors.selectById, saleId)
      ),
      filter((sale) => Boolean(sale)),
      untilDestroyed(this)
    )
    this.sale$.pipe(take(1)).subscribe((sale) => {
      this.extraFilters = {
        $or: [
          { saleId: { [CondOperator.EQUALS]: sale.id } },
          sale.payments?.length
            ? { salePaymentId: { [CondOperator.IN]: sale.payments } }
            : null,
          sale.saleItems?.length
            ? { saleItemId: { [CondOperator.IN]: sale.saleItems } }
            : null
        ].filter(Boolean)
      }
    })
  }
}
